<!-- Schema Selector Dropdown -->
@if (isSchemaSelector()) {
  <div class="flex flex-column col-12 p-4 items-center">
    <div class="flex col-12 items-center justify-center">
      <div class="mr2">
        <p>Form Type</p>
      </div>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>{{ schemaSelectorLabel() }}</mat-label>
        <mat-select
          [formControl]="schemaSelectorControl"
          (selectionChange)="onSchemaSelectionChange($event)"
        >
          @for (option of schemaSelectorOptions(); track option?.value) {
            <mat-option [value]="option?.value" [disabled]="option?._ui_disable === true">
              {{ option?.label }}
            </mat-option>
          }
        </mat-select>
        @if (schemaSelectorDescription(); as description) {
          <mat-hint class="truncate" [matTooltip]="description">{{ description }}</mat-hint>
        }
      </mat-form-field>
    </div>
  </div>
}

@if ((formErrors() === null && schemaErrors() === null) && activeSchema()) {
  <div class="flex flex-column col-12" style="height: 100%;">
    <!-- Embedded Dynamic Form -->
    @if (activeSchema(); as activeSchema) {
      <sfo-dynamic-form
        class="col-12"
        [jsonSchema]="activeSchema"
        [patchForm]="transformedPatch()"
        [renderMode]="renderMode"
        (formValue)="onFormValue($event)"
        (patchError)="onPatchError($event)"
      ></sfo-dynamic-form>
    }
  </div>
} @else if (isSchemaSelector() && previousSelectedValue() && activeSchema() === null) {
  <!-- Unsupported Type Warning -->
  <div class="flex flex-column col-12 justify-center items-center p-4">
    <sfo-admonition type="warning" title="Unsupported Type" expanded hideToggle>
      <span>Sorry, the selected type is currently unsupported.</span>
    </sfo-admonition>
  </div>
} @else {
  <!-- No Schema Selected -->

  <!-- Error States -->
  <div class="flex flex-column col-12 justify-center items-center" style="height: 100%;">
    @if (formErrors(); as error) {
      <sfo-admonition type="danger" title="Form Error" expanded hideToggle>
        <span>{{ error }}</span>
      </sfo-admonition>
    }

    @if (schemaErrors(); as error) {
      <sfo-admonition type="danger" title="Schema Error" expanded hideToggle>
        <span>{{ error }}</span>
      </sfo-admonition>
    }
  </div>
}
